import { useGoogleLogin } from '@react-oauth/google';
import { logInUserViaGoogle } from '@ictlife/core/state/actions/authAction';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { storeAndRedirectUser } from './storeAndRedirectUser';

const GoogleLogin = ({ text }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const redirect = router.query.redirect;

  const [loadingLogin, setLoadingLogin] = useState(false);

  const { setSnackInfo } = useSelector(store => store.notificationsState);

  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: codeResponse => {
      const payload = {
        code: codeResponse.code,
        redirect_uri: window.location.origin,
      };
      setLoadingLogin(true);
      logInUserViaGoogle(payload)
        .then(response => {
          storeAndRedirectUser({
            authResponse: response,
            router,
            redirect,
            dispatch,
          });
        })
        .catch(error => {
          try {
            setSnackInfo(snackInfo => ({
              ...snackInfo,
              message: error.response.data.error_message,
              open: true,
              severity: 'error',
              vertical: 'bottom',
              horizontal: 'left',
            }));
          } catch (error) {
            setSnackInfo({
              type: 'error',
              message: 'Something went wrong. Please try again later.',
            });
          }
        })
        .finally(() => setLoadingLogin(false));
    },
  });

  return (
    <div className="flex justify-center mb-4">
      <div className="relative flex items-center justify-center">
        <button
          disabled={loadingLogin}
          onClick={() => login()}
          type="button"
          className="border border-[#4285F4]/80 hover:bg-[#4285F4]/20 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#4285F4]/55"
        >
          <span className="h-6 mr-4">
            <GoogleIcon />
          </span>
          <span className="font-semibold">{text}</span>
        </button>
        {loadingLogin && (
          <div className="absolute">
            <CircularProgress size={20} />
          </div>
        )}
      </div>
    </div>
  );
};

const GoogleIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    className="LgbsSe-Bz112c h-6"
  >
    <g>
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      ></path>
      <path
        fill="#4285F4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      ></path>
      <path
        fill="#FBBC05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      ></path>
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      ></path>
      <path fill="none" d="M0 0h48v48H0z"></path>
    </g>
  </svg>
);

export default GoogleLogin;
